import projection from '../generated/pwc5m5f1.json';
import { AcceptanceManifest } from '../types';

export const pwc5m5f1AcceptanceManifest = projection as AcceptanceManifest;
